module.exports = __webpack_public_path__ + "lp/img/img_teacher_02.79328cbd.svg";